// Design tokens — Tarefas.
// Header: DESIGN_NOT_GENERIC.md (padrão Contatos).
// Kanban/calendário: referência Propostas.

export const TAREFAS_DESIGN = {
  page: {
    root: 'flex flex-col h-full min-h-0 w-full bg-[#f4f4f7] text-[#18181b] dark:bg-[#151718] dark:text-[#D1D2D3]',
    fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
    container: 'w-full px-4 md:px-6 lg:px-8',
    stickyHeader:
      'sticky top-0 z-30 bg-white border-b border-[#e7e7ec] shrink-0 dark:bg-[#1A1D21] dark:border-[#383838]',
    headerRow: 'flex flex-wrap items-center gap-2.5 py-3',
    title:
      'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b] shrink-0 mr-1.5 dark:text-[#D1D2D3]',
    topbarActions: 'flex items-center gap-2.5 flex-shrink-0',
    searchRow: 'flex items-center w-full sm:w-[240px] ml-auto min-w-0',
    searchField:
      'flex items-center gap-2.5 w-full h-10 px-3.5 rounded-lg border border-[#d4d4d8] bg-white transition-colors hover:border-[#b8b8c0] focus-within:border-[#8b5cf6] focus-within:ring-2 focus-within:ring-[#c4b5fd] dark:border-[#383838] dark:bg-[#222529]',
    searchIcon: 'flex-shrink-0 text-[#a1a1aa] hover:text-[#6d28d9] transition-colors dark:text-[#ABABAD]',
    searchInput:
      'flex-1 min-w-0 h-auto border-0 bg-transparent p-0 text-[14px] md:text-[14px] text-[#18181b] shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-[#a1a1aa] dark:text-[#D1D2D3] dark:placeholder:text-[#ABABAD]',
    body: 'flex-1 min-h-0 overflow-y-auto px-4 md:px-6 lg:px-8 pt-4 pb-6',
    controlBar: 'flex flex-wrap items-center gap-2.5 mb-3.5',
    filterField: 'min-w-0 w-full sm:w-[180px]',
    filterFieldSm: 'min-w-0 w-full sm:w-[140px]',
    filterSelect:
      'h-10 w-full rounded-lg border border-[#d4d4d8] bg-white text-[13px] text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:ring-2 focus:ring-[#c4b5fd] dark:border-[#383838] dark:bg-[#222529] dark:text-[#D1D2D3]',
    primaryButton:
      'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
    ghostButton:
      'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed dark:border-[#383838] dark:bg-[#222529] dark:text-[#ABABAD] dark:hover:bg-[#1A1D21] dark:hover:text-[#D1D2D3]',
    iconButton:
      'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] dark:border-[#383838] dark:bg-[#222529] dark:text-[#ABABAD] dark:hover:bg-[#1A1D21]',
    iconButtonActive:
      'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#a78bfa] bg-[#ede9fe] text-[#5b21b6] dark:border-violet-700 dark:bg-violet-950/40 dark:text-violet-200',
    viewToggle: 'inline-flex items-center gap-1',
    card: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 dark:bg-[#222529] dark:border-[#383838]',
    emptyState: 'flex flex-col items-center justify-center py-16 text-center px-4',
    emptyIcon:
      'mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa] dark:bg-[#1A1D21] dark:text-[#ABABAD]',
    emptyTitle: 'text-[15px] font-semibold text-[#18181b] dark:text-[#D1D2D3]',
    emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm dark:text-[#ABABAD]',
    link: 'text-[13px] font-semibold text-[#6d28d9] hover:underline',
  },
  kanban: {
    board: 'flex flex-row gap-2 overflow-x-auto pb-2 items-start',
    column:
      'flex flex-col flex-1 min-w-[220px] max-w-[300px] bg-gray-200/45 dark:bg-[#1A1D21] rounded-2xl h-fit max-h-[calc(100vh-260px)]',
    columnHeader: 'flex items-center gap-1.5 px-3 pt-2.5 pb-1.5',
    columnIconBox: 'w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0',
    columnTitle: 'text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] truncate',
    columnCount: 'ml-auto text-[11px] font-medium text-gray-400 tabular-nums flex-shrink-0',
    columnBody: 'flex-1 overflow-y-auto px-1.5 pt-1 pb-1.5 space-y-1.5 min-h-[100px]',
    columnBodyDragging: 'bg-violet-100/50 dark:bg-violet-500/10 rounded-xl',
    columnEmpty: 'flex flex-col items-center justify-center py-8 text-center',
    columnEmptyText: 'text-[11px] text-gray-400 dark:text-gray-600',
  },
  kanbanCard: {
    container:
      'bg-white dark:bg-[#222529] rounded-lg border border-gray-200/60 dark:border-[#383838] p-2 shadow-[0_1px_2px_rgba(16,24,40,0.06)] hover:shadow-[0_4px_10px_rgba(16,24,40,0.1)] hover:-translate-y-px transition-all duration-200 group',
    containerDrag: 'cursor-grab active:cursor-grabbing',
    containerClick: 'cursor-pointer',
    containerDragging: 'opacity-40 ring-2 ring-[#7C3AED]/30',
    header: 'flex items-start gap-1.5',
    avatar:
      'w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0',
    avatarEmpty:
      'w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 bg-gray-100 dark:bg-[#383838] border border-dashed border-gray-300 dark:border-[#4a4a4a] text-gray-400',
    title: 'text-xs font-semibold text-gray-900 dark:text-[#D1D2D3] leading-snug line-clamp-2',
    subtitle:
      'text-[10px] leading-tight text-gray-500 dark:text-[#ABABAD] line-clamp-1 mt-0.5 flex items-center gap-1',
    action:
      'w-5 h-5 rounded-md text-gray-300 hover:bg-gray-100 dark:hover:bg-[#383838] hover:text-[#7C3AED] flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 flex-shrink-0',
    footer:
      'flex items-center justify-between gap-1 mt-1.5 pt-1.5 border-t border-gray-100 dark:border-[#383838]/60',
    chips: 'flex items-center gap-1 min-w-0 flex-1',
    chip:
      'inline-flex items-center gap-0.5 max-w-full h-5 px-1.5 rounded-md text-[9px] font-semibold leading-none truncate transition-colors hover:bg-gray-100 dark:hover:bg-[#383838]',
    due: 'text-[9px] tabular-nums flex-shrink-0 px-1 py-0.5 rounded',
    dueRow:
      'mt-1 inline-flex items-center gap-1 max-w-full text-[11px] font-semibold tabular-nums px-1.5 py-0.5 rounded-md',
    dueMissing: 'mt-1 inline-flex items-center gap-1 text-[10px] text-gray-400 dark:text-[#ABABAD]/70',
    dueOk: 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-500/10',
    dueSoon: 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-500/10',
    dueOver: 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-500/10',
  },
  calendar: {
    toolbar:
      'flex items-center justify-between gap-2 px-4 py-3 border-b border-gray-100 dark:border-[#383838]',
    navButton:
      'px-1.5 py-1 rounded-md text-gray-500 dark:text-[#ABABAD] hover:text-[#7C3AED] hover:bg-[#7C3AED]/10 transition-all flex items-center',
    noDateTrigger:
      'flex items-center gap-1.5 h-8 px-3 rounded-lg border border-dashed border-gray-300 dark:border-[#383838] text-xs text-gray-600 dark:text-[#ABABAD] font-medium hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 dark:hover:bg-violet-900/20 transition-colors bg-transparent',
    weekday:
      'py-2 text-center text-[11px] font-bold uppercase tracking-wider text-gray-400 dark:text-[#ABABAD]',
    dayCell:
      'group/day min-h-[112px] p-1.5 border-b border-r border-gray-100 dark:border-[#383838] [&:nth-child(7n)]:border-r-0 cursor-pointer hover:bg-violet-50/40 dark:hover:bg-violet-500/5 transition-colors overflow-hidden',
    dayCellOutside: 'bg-gray-50/60 dark:bg-[#1A1D21]/40',
    dayNumber: 'w-6 h-6 flex items-center justify-center text-xs font-semibold rounded-full',
    dayNumberToday: 'bg-[#7C3AED] text-white shadow-sm shadow-[#7C3AED]/30',
    dayAddHint:
      'w-5 h-5 rounded-md flex items-center justify-center text-gray-400 hover:text-[#7C3AED] hover:bg-[#7C3AED]/10 opacity-0 group-hover/day:opacity-100 transition-all',
    chip:
      'w-full flex items-center gap-1.5 px-1.5 py-1 rounded-md text-[11px] font-medium text-left leading-none transition-colors min-w-0',
    chipInPopover: 'py-1.5',
    chipDefault:
      'bg-gray-50 dark:bg-[#1A1D21] text-gray-700 dark:text-[#D1D2D3] hover:bg-violet-100/60 dark:hover:bg-violet-500/10',
    chipOverdue:
      'bg-red-50 dark:bg-red-500/10 text-red-700 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-500/20',
    chipDone:
      'bg-gray-50/70 dark:bg-[#1A1D21]/70 text-gray-400 dark:text-gray-500 hover:bg-gray-100 dark:hover:bg-[#383838]/40',
    moreButton:
      'w-full text-left px-1.5 py-0.5 rounded-md text-[10px] font-semibold text-[#7C3AED] hover:bg-[#7C3AED]/10 transition-colors',
  },
  priority: {
    low: { label: 'Baixa', color: '#9ca3af', icon: 'mdi:arrow-down' },
    medium: { label: 'Média', color: '#f59e0b', icon: 'mdi:minus' },
    high: { label: 'Alta', color: '#f97316', icon: 'mdi:arrow-up' },
    urgent: { label: 'Urgente', color: '#ef4444', icon: 'mdi:alert-circle' },
  },
};

const AVATAR_COLORS = ['#7C3AED', '#2563EB', '#059669', '#D97706', '#DC2626', '#0891B2', '#DB2777'];

export const getCorAvatar = (nome) => {
  if (!nome) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < nome.length; i += 1) hash = nome.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getIniciais = (nome) => {
  if (!nome) return '?';
  return nome
    .trim()
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};

export const PRIORITY_ORDER = ['low', 'medium', 'high', 'urgent'];

export default TAREFAS_DESIGN;
